import columns from "./columns";
import searchFields from "./searchFields";
import formFields from "./formFields";
import previewFields from "./previewFields";

export default {
    entityName: "tags",
    pageTitle: "Tags",
    columns,
    searchFields,
    searchPlaceholder: "e.g. name:overnight",
    formFields,
    previewFields,
    tableOptions: { hideSearch: true },
    formOptions: {},
};
